import { render, staticRenderFns } from "./Faelflix.vue?vue&type=template&id=8fbea692&scoped=true&lang=pug&"
import script from "./Faelflix.vue?vue&type=script&lang=js&"
export * from "./Faelflix.vue?vue&type=script&lang=js&"
import style0 from "@components/Faelflix/Faelflix.styl?vue&type=style&index=0&id=8fbea692&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbea692",
  null
  
)

export default component.exports